import react, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { purple } from "@mui/material/colors";
import { BiLogoTypescript } from "react-icons/bi";
import {
  FaAws,
  FaDigitalOcean,
  FaDocker,
  FaGithub,
  FaJava,
  FaPhp,
  FaPython,
  FaReact,
  FaSwift,
} from "react-icons/fa";
import { RiFlutterFill } from "react-icons/ri";
import { IoLogoNodejs } from "react-icons/io";
import { TbBrandCSharp, TbBrandKotlin } from "react-icons/tb";
import { FaDartLang } from "react-icons/fa6";
import { SiGooglecloud, SiMongodb } from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { IoLogoFirebase } from "react-icons/io5";
import { VscAzure } from "react-icons/vsc";

import { FaNode } from "react-icons/fa";
import {} from "react-icons/ri";
import { SiExpress } from "react-icons/si";
import { DiMsqlServer } from "react-icons/di";

export const techStacks = {
  "FRONT-END": [
    {
      id: 1,
      name: "Java",
      icon: (
        <FaJava className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#4c7ea1] transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 2,
      name: "Kotlin",
      icon: (
        <TbBrandKotlin className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-pink-500 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 3,
      name: "Swift",
      icon: (
        <FaSwift className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-orange-500 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 4,
      name: "TypeScript",
      icon: (
        <BiLogoTypescript className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-900 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 5,
      name: "React",
      icon: (
        <FaReact className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-sky-500 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 6,
      name: "Dart",
      icon: (
        <FaDartLang className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-700 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 7,
      name: "Flutter",
      icon: (
        <RiFlutterFill className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-sky-600 transition duration-300 cursor-pointer" />
      ),
    },
  ],
  "BACK-END": [
    {
      id: 1,
      name: "Java",
      icon: (
        <FaJava className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#4c7ea1] transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 2,
      name: "Python",
      icon: (
        <FaPython className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-700 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 3,
      name: "Csharp",
      icon: (
        <TbBrandCSharp className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-500 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 4,
      name: "Node.js",
      icon: (
        <IoLogoNodejs className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-green-900 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 6,
      name: "Php",
      icon: (
        <FaPhp className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-purple-900 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 9,
      name: "Kotlin",
      icon: (
        <TbBrandKotlin className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-pink-500 transition duration-300 cursor-pointer" />
      ),
    },
  ],
  DATABASE: [
    {
      id: 1,
      name: "Mysql",
      icon: (
        <GrMysql className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-400 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 2,
      name: "MongoDb",
      icon: (
        <SiMongodb className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-green-800 transition duration-300 cursor-pointer" />
      ),
    },

    {
      id: 3,
      name: "sqlServer",
      icon: (
        <DiMsqlServer className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-400 transition duration-300 cursor-pointer" />
      ),
    },
  ],
  "DEPLOYMENT & HOSTING": [
    {
      id: 1,
      name: "Firebase",
      icon: (
        <IoLogoFirebase className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-orange-400 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 2,
      name: "AWS",
      icon: (
        <FaAws className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-yellow-500 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 3,
      name: "Google Cloud",
      icon: (
        <SiGooglecloud className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-500 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 4,
      name: "Microsoft Azure",
      icon: (
        <VscAzure className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-700 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 5,
      name: "DigitalOcean",
      icon: (
        <FaDigitalOcean className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-700 transition duration-300 cursor-pointer" />
      ),
    },
  ],
  DEVOPS: [
    {
      id: 1,
      name: "Github",
      icon: (
        <FaGithub className="text-5xl md:text-7xl text-[#a0aac7] hover:text-purple-800 transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 2,
      name: "Docker",
      icon: (
        <FaDocker className="text-5xl md:text-7xl text-[#a0aac7] hover:text-blue-900 transition duration-300 cursor-pointer" />
      ),
    },
  ],
};
